<template>
  <div class="page" id="my-account">
    <div class="card">
      <div class="sideMenu">
        <div class="summary-info">
          <user-avatar/>

          <div class="details">
            <span class="userName">{{ user.name }}</span>
            <span class="userEmail">{{ user.email }}</span>
          </div>
        </div>

        <div class="balance-info">
          <h3 class="title">Créditos</h3>
          <balance class="balance"/>
        </div>

        <ul class="menu">
          <router-link
            :to="{ name: 'Auth-My-Account-Personal-Information' }"
            v-slot="{ href, isExactActive, navigate }"
          >
            <li class="item" :class="{ '-active': isExactActive }">
              <a class="link" :href="href" @click="navigate">
                <span class="icon"><ion-icon name="options-outline"></ion-icon></span>
                Informações Pessoais
                <span class="changeView"><ion-icon name="chevron-forward-outline"></ion-icon></span>
              </a>
            </li>
          </router-link>
          <router-link
            :to="{ name: 'Auth-My-Account-Password' }"
            v-slot="{ href, isExactActive, navigate }"
          >
            <li class="item" :class="{ '-active': isExactActive }">
              <a class="link" :href="href" @click="navigate">
                <span class="icon"><ion-icon name="key-outline"></ion-icon></span>
                Senha
                <span class="changeView"><ion-icon name="chevron-forward-outline"></ion-icon></span>
              </a>
            </li>
          </router-link>
          <router-link
            :to="{ name: 'Auth-My-Account-Organization-Information' }"
            v-slot="{ href, isExactActive, navigate }"
            v-if="user.role === role.master"
          >
            <li class="item" :class="{ '-active': isExactActive }">
              <a class="link" :href="href" @click="navigate">
                <span class="icon"><ion-icon name="business-outline"></ion-icon></span>
                Informações da Empresa
                <span class="changeView"><ion-icon name="chevron-forward-outline"></ion-icon></span>
              </a>
            </li>
          </router-link>
          <router-link
            :to="{ name: 'Auth-My-Account-Tokens' }"
            v-slot="{ href, isExactActive, navigate }"
            v-if="user.role === role.master"
          >
            <li class="item" :class="{ '-active': isExactActive }">
              <a class="link" :href="href" @click="navigate">
                <span class="icon"><ion-icon name="swap-horizontal-outline"></ion-icon></span>
                Tokens
                <span class="changeView"><ion-icon name="chevron-forward-outline"></ion-icon></span>
              </a>
            </li>
          </router-link>
          <router-link
            :to="{ name: 'Auth-My-Account-Users-List' }"
            v-slot="{ href, isExactActive, navigate }"
            v-if="user.role === role.master"
          >
            <li class="item" :class="{ '-active': isExactActive }">
              <a class="link" :href="href" @click="navigate">
                <span class="icon"><ion-icon name="people-outline"></ion-icon></span>
                Usuários
                <span class="changeView"><ion-icon name="chevron-forward-outline"></ion-icon></span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>

      <div class="formSide card">
        <div class="header">
          <div class="description">
            <h2 class="title">{{ $route.meta.title }}</h2>
            <p class="subtitle">{{ $route.meta.subtitle }}</p>
          </div>

          <card-actions v-if="$route.meta.createRoute">
            <router-link
              :to="$route.meta.createRoute"
              class="btn btn-primary -sm"
            >Novo Usuário<ion-icon name="add"></ion-icon></router-link>
          </card-actions>
        </div>

        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UserAvatar from '@/users/components/UserAvatar.vue';
import Balance from '@/credits/components/Balance.vue';
import CardActions from '@/support/components/card/CardActions.vue';

export default {
  name: 'MyAccount',

  data() {
    return {
      form: {},
    };
  },

  computed: {
    ...mapState('auth', {
      user: 'user',
      role: 'role',
    }),
  },

  components: {
    UserAvatar,
    Balance,
    CardActions,
  },
};
</script>

<style lang="scss" scoped>
  #my-account {
    > .card {
      @apply flex;

      @screen md {
        @apply flex-row;
      }

      > .card {
        > .header {
          padding: 0 0 1.5rem 0;
        }
      }

      > .sideMenu {
        border-right: 1px solid #dbdfea;

        @screen md {
          width: 300px;
        }

        > .summary-info {
          display: none;

          @screen md {
            padding: 1.5rem;
            border-bottom: 1px solid #dbdfea;
            align-items: flex-start;
            @apply flex;

            > .avatar {
              box-shadow: 0px 0px 12px 0px rgba(115, 102, 255, 0.35);
              background: transparent;
              padding: 0;
              flex-shrink: 0;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              line-height: 1;
              border-radius: 10px;
              outline: none;
              width: 32px;
              height: 32px;
            }

            > .details {
              margin-left: 9px;
              margin-top: -5px;
              flex: 1;

              > .userName {
                @apply text-sm;
                color: #2b2b2b;
                font-weight: 700;
                display: block;
              }

              > .userEmail {
                @apply text-xs;
                @apply relative;
                top: -6px;
                color: #8094ae;
              }
            }
          }
        }

        > .balance-info {
          display: none;

          @screen md {
            display: block;
            padding: 1.5rem;
            border-bottom: 1px solid #dbdfea;

            > .title {
              @apply text-secondary-700;
              @apply uppercase;
              @apply text-sm;
              @apply mb-1;
              letter-spacing: .05em;
            }

            > .balance {
              &:not(.-loading) {
                @apply text-2xl;
                @apply text-primary-500;
              }

              &.-loading {
                height: 36px;
              }
            }
          }
        }

        > .menu {
          padding: 1.5rem;

          > .item {
            > .link {
              @apply flex;
              @apply text-xs;
              align-items: center;
              position: relative;
              color: theme('colors.secondary.700');
              border-radius: 10px;
              margin: 5px 0;
              font-weight: 500;

              > .icon {
                @apply text-xl;
                padding-right: 10px;
                position: relative;
                top: 2px;
              }

              > .changeView {
                @apply relative;
                top: 2px;
                @apply ml-auto;
              }
            }

            &:not(:first-child) {
              > .link {
                padding-top: 1rem;
              }
            }

            &:not(:last-child) {
              > .link {
                padding-bottom: 1rem;
              }
            }

            &:hover,
            &.-active {
              > .link {
                color: theme('colors.primary.500');
              }
            }
          }
        }
      }

      > .formSide {
        @apply flex-1;
        @apply relative;
        padding: 1.5rem;

        > .title {
          @apply text-secondary-700;
          @apply uppercase;
          @apply text-sm;
          @apply font-bold;
          letter-spacing: .05em;
        }

        > .subtitle {
          @apply text-secondary-600;
          @apply text-xs;
          @apply mb-4;
        }
      }
    }
  }
</style>
